import { isString, waitForState } from '@cutwise/utils';

import { CarbonViewerVersion } from '@/carbonViewer/types/CarbonViewerVersions';

const ACTIVE_VERSION_CHECK_INTERVAL_MS = 500;
const ACTIVE_VERSION_WAIT_TIMEOUT_MS = 5 * 60 * 1000; // 5 mins

class CarbonViewerRepository {
  private cdnURL?: string;
  private carbonViewerVersions: CarbonViewerVersion[] = [];

  initCarbonViewerVersions(url: string, versions: CarbonViewerVersion[]) {
    this.cdnURL = url;
    this.carbonViewerVersions = versions;
  }

  get path() {
    return this.cdnURL!;
  }

  get activeVersion() {
    return this.carbonViewerVersions.find(({ active }) => !!active)?.ver ?? null;
  }

  get versions() {
    return this.carbonViewerVersions;
  }

  isVersionActive(version: string) {
    return this.activeVersion === version;
  }

  async waitForActiveVersion() {
    if (isString(this.activeVersion)) {
      return;
    }

    try {
      await waitForState(
        () => isString(this.activeVersion),
        ACTIVE_VERSION_CHECK_INTERVAL_MS,
        ACTIVE_VERSION_WAIT_TIMEOUT_MS,
      );
    } catch {
      throw new Error('Carbon viewer active version is not available');
    }
  }
}

export const carbonViewerRepository = new CarbonViewerRepository();
